import React from 'react'
import { useTranslation } from 'react-i18next'

interface PasswordPolicyIndicatorProps {
    password: string;
    onValidChange?: (isValid: boolean) => void;
}

const rules = [
    { check: (pw: string) => pw.length >= 8, key: 'passwordPolicy.minLength' },
    { check: (pw: string) => pw.length <= 64, key: 'passwordPolicy.maxLength' },
]

const PasswordPolicyIndicator: React.FC<PasswordPolicyIndicatorProps> = ({ password, onValidChange }) => {
    const { t } = useTranslation()

    const results = rules.map(rule => ({
        label: t(rule.key),
        passed: password.length > 0 ? rule.check(password) : false,
    }))

    const allPassed = password.length > 0 && results.every(r => r.passed)

    React.useEffect(() => {
        onValidChange?.(allPassed)
    }, [allPassed, onValidChange])

    if (password.length === 0) return null

    return (
        <div className={'flex flex-col gap-[4px] mt-[6px] text-xs'}>
            {results.map(({ label, passed }) => (
                <div key={label} className={'flex items-center gap-[4px]'}>
                    <span className={passed ? 'text-green-600' : 'text-red-500'}>
                        {passed ? '✓' : '✗'}
                    </span>
                    <span className={passed ? 'text-gray-600' : 'text-red-500'}>
                        {label}
                    </span>
                </div>
            ))}
            <p className={'text-gray-500'}>{t('passwordPolicy.serverRule')}</p>
        </div>
    )
}

export default PasswordPolicyIndicator
